import {
  GetRCodeMaster,
  GetPCodeMaster,
  GetFCodeMaster,
  GetRCodePartsMaster,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';
import { formatQueryDateTime } from '../../_utils/utils';

const endPointPCodeMaster = 'p-code-master';
const endPointFCodeMaster = 'f-code-master';
const endPointRCodeMaster = 'r-code-master';
const endPointRCodePartsMaster = 'r-code-parts-master';

export interface PFRCodeMasterSearchParam {
  code?: string;
  updateTimeFrom?: string;
  updateTimeTo?: string;
  name?: string;
  eName?: string;
  jName?: string;
}

export interface RCodePartsMasterSearchParam {
  code?: string;
  modelName?: string;
  market?: number;
}

export const getPCodeMaster = async (
  params: PFRCodeMasterSearchParam,
): Promise<GetPCodeMaster[]> => {
  const queryParams = new URLSearchParams();

  if (params.code) {
    queryParams.append('code', params.code);
  }
  if (params.updateTimeFrom) {
    queryParams.append(
      'updateTimeFrom',
      formatQueryDateTime(params.updateTimeFrom, true),
    );
  }
  if (params.updateTimeTo) {
    queryParams.append(
      'updateTimeTo',
      formatQueryDateTime(params.updateTimeTo, false),
    );
  }
  if (params.name) {
    queryParams.append('name', params.name);
  }
  if (params.eName) {
    queryParams.append('eName', params.eName);
  }
  if (params.jName) {
    queryParams.append('jName', params.jName);
  }

  const apiUrl = getApiUrl(endPointPCodeMaster);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const getFCodeMaster = async (
  params: PFRCodeMasterSearchParam,
): Promise<GetFCodeMaster[]> => {
  const queryParams = new URLSearchParams();

  if (params.code) {
    queryParams.append('code', params.code);
  }
  if (params.updateTimeFrom) {
    queryParams.append(
      'updateTimeFrom',
      formatQueryDateTime(params.updateTimeFrom, true),
    );
  }
  if (params.updateTimeTo) {
    queryParams.append(
      'updateTimeTo',
      formatQueryDateTime(params.updateTimeTo, false),
    );
  }
  if (params.name) {
    queryParams.append('name', params.name);
  }
  if (params.eName) {
    queryParams.append('eName', params.eName);
  }
  if (params.jName) {
    queryParams.append('jName', params.jName);
  }

  const apiUrl = getApiUrl(endPointFCodeMaster);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const getRCodeMaster = async (
  params: PFRCodeMasterSearchParam,
): Promise<GetRCodeMaster[]> => {
  const queryParams = new URLSearchParams();

  if (params.code) {
    queryParams.append('code', params.code);
  }
  if (params.updateTimeFrom) {
    queryParams.append(
      'updateTimeFrom',
      formatQueryDateTime(params.updateTimeFrom, true),
    );
  }
  if (params.updateTimeTo) {
    queryParams.append(
      'updateTimeTo',
      formatQueryDateTime(params.updateTimeTo, false),
    );
  }
  if (params.name) {
    queryParams.append('name', params.name);
  }
  if (params.eName) {
    queryParams.append('eName', params.eName);
  }
  if (params.jName) {
    queryParams.append('jName', params.jName);
  }

  const apiUrl = getApiUrl(endPointRCodeMaster);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const getRCodePartsMaster = async (
  params: RCodePartsMasterSearchParam,
): Promise<GetRCodePartsMaster[]> => {
  const queryParams = new URLSearchParams();

  if (params.code) {
    queryParams.append('code', params.code);
  }
  if (params.modelName) {
    queryParams.append('modelName', params.modelName);
  }
  if (params.market && params.market !== -1) {
    queryParams.append('market', params.market.toString());
  }

  const apiUrl = getApiUrl(endPointRCodePartsMaster);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });
  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );

  return response.data;
};
